import { render } from "./OrganisationsRoot.vue?vue&type=template&id=4b8df0f4&ts=true"
import script from "./OrganisationsRoot.vue?vue&type=script&lang=ts"
export * from "./OrganisationsRoot.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/tps-web-admin-portal/tps-web-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__